import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { INDUSTRIES_SIGNED, INDUSTRIES_WELCOME } from "../../config/site";
import { Check, Factory } from "lucide-react";

export const Industries = () => (
  <Section
    id="industries"
    overline="Who belongs here"
    title="Every manufacturing unit is welcome"
    sub="If you make things, BIDC is zoned, approved and ready for you."
  >
    <div className="grid gap-10 lg:grid-cols-2">
      <Reveal>
        <div>
          <h3 className="font-display text-2xl font-medium text-forest">Industries welcome</h3>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2">
            {INDUSTRIES_WELCOME.map((ind) => (
              <li
                key={ind}
                className="flex items-center gap-2.5 border border-border bg-paper-light px-4 py-3 text-sm text-ink"
                data-testid={`industry-${ind.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <Check className="h-4 w-4 shrink-0 text-gold" /> {ind}
              </li>
            ))}
          </ul>
          <div className="mt-6 border-l-2 border-gold bg-gold-pale/40 px-5 py-4">
            <p className="text-sm leading-relaxed text-[#4A4C4A]">
              <strong className="text-forest">Packaging makers & transporters:</strong> an estate of
              factories needs both — a ready customer base at your gate.
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="h-full bg-forest p-7 sm:p-9 grain relative" data-testid="industries-signed">
          <div className="relative">
            <div className="flex items-center gap-3">
              <Factory className="h-6 w-6 text-gold" strokeWidth={1.5} />
              <h3 className="font-display text-2xl font-medium text-paper">Already signed up</h3>
            </div>
            <p className="mt-3 text-sm text-paper/60">
              Units that have already chosen BIDC — your future neighbours.
            </p>
            <div className="mt-6 flex flex-wrap gap-2.5">
              {INDUSTRIES_SIGNED.map((s) => (
                <span
                  key={s}
                  className="border border-paper/20 bg-forest-light/50 px-3.5 py-1.5 text-sm text-paper/85"
                >
                  {s}
                </span>
              ))}
            </div>
            <p className="mt-8 font-display text-lg italic text-gold">
              "जो पहले आता है, वो अपनी जगह पहले चुनता है।"
            </p>
            <p className="mt-1 text-xs text-paper/50">Early movers pick the best plots.</p>
          </div>
        </div>
      </Reveal>
    </div>
  </Section>
);
